<template src="./template/index.html"></template>
<script>
import Datepicker from "vuejs-datepicker";
import DibbleJS from "../../../dibble";

export default {
    name: "MoorageRefundModal",
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        item: {
            type: Object,
            default: () => {
                return null
            }
        },
    },
    components: { Datepicker },
    data() {
        return {
            dibbleJs: DibbleJS,
            refundAmount: '',
        }
    },
    methods: {
        closeModal() {
            this.$emit("close");
        },
        submitAmount() {
          this.$emit("submit", this.refundAmount);
        }
    },
}
</script>

<style lang="scss">
.modal {
    background: transparent;
    transition: opacity 0.15s linear;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    .modal-form {
        display: flex;
        height: auto;
        align-items: center;
        .content {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin: 8px;
            width: 100%;
            .title {
                font-size: 14px;
                margin: 0;
                margin-right: 10px;
            }
        }
    }
    button {
        float: right;
    }
}
.modal-fade-enter,
.modal-fade-leave-active {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity 0.5s ease;
}

.dollar-sign-prepend {
 color: #969fa2;
 position: absolute;
 bottom: 10px;
 left: 13px;
 font-size: 16px;
}
</style>
